import { Check, X } from 'lucide-react';
import { cn } from '../../utils';

const PaymentStatusJourney = ({ status, isRejected, obtainedAuthorisations }) => {
    const skipPartial = isRejected && obtainedAuthorisations === 0;

    const getLineTone = (index) => {
        if (isRejected) {
            if (index === 0 && obtainedAuthorisations > 0) return 'complete';
            if (index === 1) return 'rejected';
            if (index === 0 && obtainedAuthorisations === 0) return 'rejected';
        }
        return status > index ? 'complete' : 'inactive';
    };

    const lineClassName = (tone) => cn(
        'h-px w-full rounded-full',
        tone === 'complete' && 'bg-yavrio-green',
        tone === 'rejected' && 'bg-red-400',
        tone === 'inactive' && 'bg-slate-200',
    );

    const renderCircle = (index, isRejectedCircle = false) => {
        if (isRejectedCircle) {
            return (
                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-red-500 bg-red-500 text-white shadow-sm">
                    <X className="h-3.5 w-3.5" strokeWidth={2.5} />
                </div>
            );
        }

        if (status >= index) {
            return (
                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-yavrio-green bg-yavrio-green text-white shadow-sm">
                    <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
                </div>
            );
        }

        return (
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-slate-200 bg-white">
                <span className="h-2 w-2 rounded-full bg-slate-200" />
            </div>
        );
    };

    const StepLabel = ({ title, subtitle, active }) => (
        <div className={cn('mt-3 text-center', active ? 'text-slate-600' : 'text-slate-400')}>
            <p className="mb-0 text-xs font-medium leading-tight">{title}</p>
            {subtitle && <p className="mb-0 text-xs leading-tight mt-0.5">{subtitle}</p>}
        </div>
    );

    const Connector = ({ tone }) => (
        <div className="flex flex-1 items-center self-start px-2 pt-4 min-w-[1.5rem]">
            <div className={lineClassName(tone)} />
        </div>
    );

    const Step = ({ circle, title, subtitle, active }) => (
        <div className="flex w-24 shrink-0 flex-col items-center">
            {circle}
            <StepLabel title={title} subtitle={subtitle} active={active} />
        </div>
    );

    if (skipPartial) {
        return (
            <div className="flex w-full max-w-md items-start">
                <Step
                    circle={renderCircle(0)}
                    title="Awaiting"
                    subtitle="authorisation"
                    active={status >= 0}
                />
                <Connector tone={getLineTone(0)} />
                <Connector tone={getLineTone(1)} />
                <Step
                    circle={renderCircle(2, true)}
                    title="Rejected"
                    active
                />
            </div>
        );
    }

    return (
        <div className="flex w-full max-w-md items-start">
            <Step
                circle={renderCircle(0)}
                title="Awaiting"
                subtitle="authorisation"
                active={status >= 0}
            />
            <Connector tone={getLineTone(0)} />
            <Step
                circle={renderCircle(1)}
                title="Partial"
                subtitle="authorisation"
                active={status >= 1}
            />
            <Connector tone={getLineTone(1)} />
            <Step
                circle={renderCircle(2, isRejected)}
                title={isRejected ? 'Rejected' : 'Authorised'}
                subtitle={null}
                active={status >= 2 || isRejected}
            />
        </div>
    );
};

export default PaymentStatusJourney;
